import React, { Component } from "react";
import { Link } from "react-router-dom";
import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class UserInfoRow extends Component {
  state = {};
  render() {
    return (
      <div className="row max_width_300">
        <div className="width_profile  cursor_btn">
          <Link
            className="btn"
            to={{
              pathname: "/users/" + this.props.user.username + "/following"
            }}
          >
            <label className="name cursor_btn">
              {this.props.user.total_following}
            </label>
            <label className="user_data cursor_btn">{strings.following}</label>
          </Link>
        </div>
        <div className="separator" />
        <div className="width_profile cursor_btn">
          <Link
            className="btn"
            to={{
              pathname: "/users/" + this.props.user.username + "/followers"
            }}
          >
            <label className="name cursor_btn">
              {this.props.user.total_followers}
            </label>
            <label className="user_data cursor_btn">{strings.followers}</label>
          </Link>
        </div>
        {/* <div className="separator" />
        <div className="width_profile cursor_btn">
          <Link
            className="btn"
            to={{ pathname: "/users/" + this.props.user.username + "/likes" }}
          >
            <label className="name cursor_btn">
              {parseInt(this.props.user.total_likes, 10) || 0}
            </label>
            <label className="user_data cursor_btn">{strings.likes}</label>
          </Link>
        </div> */}
      </div>
    );
  }
}

export default UserInfoRow;



// WEBPACK FOOTER //
// ./src/components/profile/user_info_row.jsx